// src/components/IncomeTracker.jsx
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { setIncomePeriod } from '../store/dashboardSlice';

export function IncomeTracker() {
  const dispatch = useDispatch();
  const { period, data } = useSelector(s => s.dashboard.income);

  const options = {
    chart: { type: 'column', backgroundColor: null, height: 120 },
    title: { text: null },
    xAxis: { categories: ['S','M','T','W','T','F','S'], labels:{ style:{ fontSize:'10px' } } },
    yAxis: { visible: false },
    tooltip: { enabled: false },
    credits: { enabled: false },
    series: [{ data }]
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">Income Tracker</h3>
        <select
          className="border-gray-200 rounded px-3 py-1 text-sm"
          value={period}
          onChange={e => dispatch(setIncomePeriod(e.target.value))}
        >
          <option>Week</option>
          <option>Month</option>
          <option>Year</option>
        </select>
      </div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
